export const NAV_ITEMS = [
  { label: "Dashboard", href: "/" },        // 👈 Home
  { label: "Venta", href: "/venta" },
  { label: "Caja", href: "/caja" },
  { label: "Reportes", href: "/reportes" },
  { label: "Almacén", href: "/almacen" },
  { label: "Productos", href: "/productos" },
  { label: "Proveedores", href: "/proveedores" },
  { label: "Configuración", href: "/config" },
];
